import { Box, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import TelegramIcon from '@mui/icons-material/Telegram';
import EmailIcon from '@mui/icons-material/Email';
import { ChannelTypeCard } from './ChannelTypeCard';
import { ChannelType } from '../../types/chat.types';
import { ZapyIcon } from '../icons/ZapyIcon';

interface ChannelTypeSelectorProps {
  onSelectChannel: (channelType: ChannelType) => void;
}

export const ChannelTypeSelector = ({ onSelectChannel }: ChannelTypeSelectorProps) => {
  const translate = useTranslate();

  const channelTypes = [
    {
      key: ChannelType.ZAPY,
      title: translate('resources.channel.wizard.types.zapy.title'),
      description: translate('resources.channel.wizard.types.zapy.description'),
      icon: <ZapyIcon fontSize={28} />,
      iconColor: '#00b894',
      enabled: true,
    },
    {
      key: ChannelType.TELEGRAM,
      title: translate('resources.channel.wizard.types.telegram.title'),
      description: translate('resources.channel.wizard.types.telegram.description'),
      icon: <TelegramIcon sx={{ fontSize: 28, color: '#0088CC' }} />,
      iconColor: '#0088CC',
      enabled: true,
    },
    {
      key: ChannelType.EMAIL,
      title: translate('resources.channel.wizard.types.email.title'),
      description: translate('resources.channel.wizard.types.email.description'),
      icon: <EmailIcon sx={{ fontSize: 28, color: '#EA4335' }} />,
      iconColor: '#EA4335',
      enabled: true,
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom fontWeight="medium">
        {translate('resources.channel.wizard.selectChannel')}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        {translate('resources.channel.wizard.selectChannelDescription')}
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
        {channelTypes.map((channel) => (
          <Box key={channel.key} sx={{ flex: '1 1 280px', maxWidth: { xs: '100%', sm: '400px' } }}>
            <ChannelTypeCard
              title={channel.title}
              description={channel.description}
              icon={channel.icon}
              iconColor={channel.iconColor}
              onClick={() => onSelectChannel(channel.key)}
              disabled={!channel.enabled}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
